export default "__VITE_ASSET__BSsM4Bxf__"